import i18n from "i18next";

export function columnsContacts() {
  return [
    {
      id: "companyname",
      label: i18n.t("column.company_name"),
      minWidth: 140,
      maxWidth: 190,
      align: "left",
      // format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "countrycodepost",
      label: i18n.t("column.post_address"),
      minWidth: 120,
      maxWidth: 150,
      align: "left",
      // format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "contact_persons",
      label: i18n.t("column.contact_persons"),
      minWidth: 100,
      maxWidth: 160,
      align: "left",
      // format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "email1",
      label: i18n.t("column.primary_email"),
      minWidth: 100,
      maxWidth: 140,
      align: "left",
      // format: (value) => value.toLocaleString("en-US"),
    },
  ];
}
